/**
 * Find the currently active element, penetrating shadow roots
 */
export default () => {
    let node = document.activeElement;
    while (node && node.shadowRoot)
        node = node.shadowRoot.activeElement;
    return node;
};
